import axios from "axios";

const baseApiUrl =
  process.env.REACT_APP_API_LOGIN_URL ||
  "https://api-dev-scoringcapture.lanetalk.com/v1";

const instance = axios.create({
  baseURL: `${baseApiUrl}/scorecard/setting`,
});

const loadTablesSettings = ({ access_token }) => {
  return instance
    .get(``, {
      headers: { Authorization: `Bearer ${access_token}` },
    })
    .then(({ data }) => data)
    .catch((e) => {
      return { success: false, message: e.response?.data?.error };
    });
};

const saveTablesSettings = ({ access_token }, data) => {
  return instance
    .post(``, data, {
      headers: { Authorization: `Bearer ${access_token}` },
    })
    .then(({ data }) => data)
    .catch((e) => {
      return { success: false, message: e.response?.data?.error };
    });
};

export { loadTablesSettings, saveTablesSettings };
